import React from "react";
import { FaSearch, FaTimes } from "react-icons/fa";

import { formatRoomTypes } from "./reservationExportUtils";
import { getReservationNo } from "./reservationViewUtils";

const normalize = (value) => String(value || "").toLowerCase().trim();

const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

const alnumOnly = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

/**
 * Match against fields the user can see (or look up), not hidden substrings
 * of the full Firestore doc id — that was returning unrelated rows.
 */
export const reservationMatchesSearch = (reservation, query) => {
  const q = normalize(query);
  if (!q) return true;

  const reservationNo = getReservationNo(reservation);
  const visibleText = [
    [reservation.firstName, reservation.lastName].filter(Boolean).join(" "),
    reservation.mobile,
    reservation.passport,
    reservation.checkIn,
    reservation.checkOut,
    reservation.hotelName,
    formatRoomTypes(reservation.roomDetails),
    reservation.source,
    reservationNo,
  ].map(normalize);

  if (visibleText.some((field) => field.includes(q))) return true;

  const qAlnum = alnumOnly(q);
  if (qAlnum && alnumOnly(reservationNo).includes(qAlnum)) return true;

  // Full doc id only when the query is longer than the visible reservation no
  // (user pasted a real id / long fragment).
  if (qAlnum.length > 6 && alnumOnly(reservation.id).includes(qAlnum)) {
    return true;
  }

  const qDigits = digitsOnly(q);
  if (
    qDigits.length > 0 &&
    (digitsOnly(reservation.mobile).includes(qDigits) ||
      digitsOnly(reservation.passport).includes(qDigits))
  ) {
    return true;
  }

  return false;
};

const ReservationSearch = ({ value, onChange, placeholder }) => {
  return (
    <div className="mb-3">
      <label className="form-label mb-1">Search reservations</label>
      <div className="position-relative">
        <FaSearch
          style={{
            position: "absolute",
            left: 12,
            top: "50%",
            transform: "translateY(-50%)",
            color: "#6c757d",
            fontSize: 13,
            pointerEvents: "none",
          }}
        />
        <input
          type="text"
          className="form-control"
          style={{ paddingLeft: 36, paddingRight: value ? 36 : undefined }}
          value={value}
          placeholder={
            placeholder ||
            "Name, phone, CNIC/passport, dates, hotel, room type, reservation no"
          }
          onChange={(event) => onChange(event.target.value)}
        />
        {value ? (
          <button
            type="button"
            title="Clear search"
            onClick={() => onChange("")}
            style={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
              border: "none",
              background: "transparent",
              color: "#6c757d",
              cursor: "pointer",
              padding: 4,
              lineHeight: 1,
            }}
          >
            <FaTimes />
          </button>
        ) : null}
      </div>
      <div className="form-text">
        Matches visible list fields. Reservation no supports partial match;
        search looks across all dates.
      </div>
    </div>
  );
};

export default ReservationSearch;
